module.exports = __webpack_public_path__ + "img/logo_g.817d8e00.png";